import validate from "C:/Users/BenjaminGrand/Documents/live-display/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-sy_02de69f4a88b6da66d3766b992f88af3/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "C:/Users/BenjaminGrand/Documents/live-display/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-sy_02de69f4a88b6da66d3766b992f88af3/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}